var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hh-accent-panel',{staticClass:"attributions-panel"},[_c('h3',[_vm._v(_vm._s(_vm.myResources.title))]),_c('p',[_vm._v(_vm._s(_vm.myResources.introText))]),_c('p',[_c('a',{staticClass:"attributions-panel__link",on:{"click":_vm.onAttributionsClick}},[_vm._v(_vm._s(_vm.myResources.linkText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }